import { useState, useCallback, useEffect } from "react";
import type { GeneratedSlides } from "../types";
import {
  loadPresentationsFromStorage,
  savePresentationToStorage,
  deletePresentationFromStorage,
} from "../api";

export function useSlidesStorage() {
  const [savedPresentations, setSavedPresentations] = useState<
    GeneratedSlides[]
  >([]);
  const [isLoading, setIsLoading] = useState(true);

  const loadPresentations = useCallback(async () => {
    setIsLoading(true);
    try {
      const presentations = await loadPresentationsFromStorage();
      setSavedPresentations(presentations);
    } catch (error) {
      console.error("Erro ao carregar apresentações:", error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const savePresentation = useCallback(
    async (presentation: GeneratedSlides) => {
      try {
        const key = `presentation:${presentation.id}`;
        await savePresentationToStorage(key, presentation);
        await loadPresentations();
        return true;
      } catch (error) {
        console.error("Erro ao salvar:", error);
        return false;
      }
    },
    [loadPresentations],
  );

  const deletePresentation = useCallback(
    async (id: string) => {
      try {
        await deletePresentationFromStorage(id);
        await loadPresentations();
        return true;
      } catch (error) {
        console.error("Erro ao excluir:", error);
        return false;
      }
    },
    [loadPresentations],
  );

  useEffect(() => {
    loadPresentations();
  }, [loadPresentations]);

  return {
    savedPresentations,
    isLoading,
    savePresentation,
    deletePresentation,
    loadPresentations,
  };
}
